import { lazy } from "react";
import Loadable from "app/components/Loadable";

const ProcessorList = Loadable(lazy(() => import("./ProcessorList")));
const ProcessorAdd = Loadable(lazy(() => import("./ProcessorAdd")));

const ProcessorRoutes = [
  { path: "/asset/processor", element: <ProcessorList /> },
  { path: "/asset/processor/:mode/:id", element: <ProcessorAdd /> },
];

export default ProcessorRoutes;
